/* eslint-disable import/first, camelcase, no-multi-assign */
import 'babel-polyfill';
import jQuery from './vendors/jquery.min';
import './vendors/pko-cookie.min';

window.$ = window.jQuery = jQuery;

import browserCheck from './modules/browser-check';
import sticky_IE_Fix from './modules/ie-fix';

class App {

  constructor() {
    this.$body = $(document.body);

    this.init();
  }

  init() {
    this.initAboveTheFold();
    this.initPage();
  }

  initAboveTheFold() {
    browserCheck();
    sticky_IE_Fix();
  }

  initPage() {
    this.initArchivePage();
    this.initArticlePage();
    this.initCategoryPage();
    this.initEncyclopediaPage();
    this.initGalleryPage();
    this.initHomepagePage();
    this.initQuizPage();
    this.initSubpagePage();
    this.initSearchPage();
    this.initSurveyPage();
    this.initErrorPage();
  }

  initArchivePage() {
    if(this.$body.hasClass('js-archive-page')) {
      return import(/* webpackChunkName: "archive-page" */ './pages/archive-page').then(({ default: ArchivePage }) => {
          this.archivePage = ArchivePage.initialize();
      }).catch(error => { console.error('An error occurred while loading the archive page'); console.error(error); });
    }
  }

  initArticlePage() {
    if(this.$body.hasClass('js-article-page')) {
      return import(/* webpackChunkName: "article-page" */ './pages/article-page').then(({ default: ArticlePage }) => {
          this.articlePage = ArticlePage.initialize();
      }).catch(error => { console.error('An error occurred while loading the article page'); console.error(error); });
    }
  }

  initCategoryPage() {
    if(this.$body.hasClass('js-category-page')) {
      return import(/* webpackChunkName: "category-page" */ './pages/category-page').then(({ default: CategoryPage }) => {
          this.categoryPage = CategoryPage.initialize();
      }).catch(error => { console.error('An error occurred while loading the category page'); console.error(error); });
    }
  }

  initEncyclopediaPage() {
    if(this.$body.hasClass('js-encyclopedia-page')) {
      return import(/* webpackChunkName: "encyclopedia-page" */ './pages/encyclopedia-page').then(({ default: EncyclopediaPage }) => {
          this.encyclopediaPage = EncyclopediaPage.initialize();
      }).catch(error => { console.error('An error occurred while loading the encyclopedia page'); console.error(error); });
    }
  }

  initGalleryPage() {
    if(this.$body.hasClass('js-gallery-page')) {
      return import(/* webpackChunkName: "gallery-page" */ './pages/gallery-page').then(({ default: GalleryPage }) => {
          this.galleryPage = GalleryPage.initialize();
      }).catch(error => { console.error('An error occurred while loading the gallery page'); console.error(error); });
    }
  }

  initHomepagePage() {
    if(this.$body.hasClass('js-homepage-page')) {
      return import(/* webpackChunkName: "homepage-page" */ './pages/homepage-page').then(({ default: HomepagePage }) => {
          this.homepagePage = HomepagePage.initialize();
      }).catch(error => { console.error('An error occurred while loading the homepage page'); console.error(error); });
    }
  }

  async initQuizPage() {
    if(this.$body.hasClass('js-quiz-page')) {
      try {
        await this.loadQuizBody();
        await this.loadQuizClass();
      } catch(error) {
        console.error('An error occurred while loading the quiz page');
        console.error(error);
      }
    }
  }

  loadQuizBody() {
    return new Promise((resolve, reject) => {
      let $body = $(document.body);
      let url = window.location;

      $.get(url, { bs: (+ new Date()) })
        .done((response) => {
          let $newBody = $(response).find('body');

          $body.html($newBody.html());

          $body.find('.loading-element').remove();

          resolve();
        })
        .fail((error) => {
          reject();
        });
    });
  }

  loadQuizClass() {
    return import(/* webpackChunkName: "quiz-page" */ './pages/quiz-page').then(({ default: QuizPage }) => {
      this.quizPage = QuizPage.initialize();
    });
  }

  initSubpagePage() {
    if(this.$body.hasClass('js-subpage-page')) {
      return import(/* webpackChunkName: "subpage-page" */ './pages/subpage-page').then(({ default: SubpagePage }) => {
          this.subpagePage = SubpagePage.initialize();
      }).catch(error => { console.error('An error occurred while loading the subpage page'); console.error(error); });
    }
  }

  initSearchPage() {
    if(this.$body.hasClass('js-search-page')) {
      return import(/* webpackChunkName: "search-page" */ './pages/search-page').then(({ default: SearchPage }) => {
          this.searchPage = SearchPage.initialize();
      }).catch(error => { console.error('An error occurred while loading the search page'); console.error(error); });
    }
  }

  initSurveyPage() {
    if(this.$body.hasClass('js-survey-page')) {
      return import(/* webpackChunkName: "survey-page" */ './pages/survey-page').then(({ default: SurveyPage }) => {
          this.surveyPage = SurveyPage.initialize();
      }).catch(error => { console.error('An error occurred while loading the survey page'); console.error(error); });
    }
  }

  initErrorPage() {
    if (this.$body.hasClass('js-error-page')) {
      return import(/* webpackChunkName: "error-page" */ './pages/error-page').then(({ default: ErrorPage }) => {
        this.errorPage = ErrorPage.initialize();
      }).catch(error => { console.error('An error occurred while loading the error page'); console.error(error); });
    }
  }



  //initModules() {
     //background();
     //parallax();
     //featured_posts_carousel();
     //categoryCarousel();
     //offTopicCarousel();
     //masonryGallery();
     //progressIndicator();
     //chart();
     //toggleContent();
     //lightBox();
     //tabs();
     //accordion();
     //
  //}

}

document.addEventListener('DOMContentLoaded', () => {
  new App(); // eslint-disable-line no-new
});



// WEBPACK FOOTER //
// ./front/bankomania/js/main.js